import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Form,Field,Button,Uploader,Picker,Popup,DatetimePicker,Cascader } from 'vant';

Vue.use(ElementUI);
Vue.use(Form)
Vue.use(Field);
Vue.use(Button);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Cascader);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
